<template>
	<div data-abr-sticky>
		<ul class="tabs race-schedule-tabs show-for-medium">
			<tab mode="all" text="All"></tab>
			<tab mode="signature" text="Signature Races"></tab>
			<tab mode="triple-crown" text="Triple Crown"></tab>
			<tab mode="breeders-cup" text="Breeders' Cup"></tab>
			<li class="month-filter">
				<select v-model="month">
					<option v-for="month in months" :value="month.value">
						{{ month.text }}
					</option>
				</select>
			</li>
		</ul>
		<a class="expanded icon-button button hide-for-medium" href="#" @click.prevent="showMobileFilters">
			Filter Schedule
			<img v-icon.literal="filter.svg" alt="Filter" class="svg"/>
		</a>
	</div>
	<div class="mobile-filters mobile-overlay" data-scroll-overlay :class="{ 'visible': mobileFilters }">
		<a class="close icon-button" href="#" @click.prevent="hideMobileFilters">
			<img v-icon.literal="close.svg" alt="Close" class="svg" />
		</a>
		<div class="list-container">
			<ul>
				<tab mode="all" text="All" @change-mode="changeMode"></tab>
				<tab mode="signature" text="Signature Races" @change-mode="changeMode"></tab>
				<tab mode="triple-crown" text="Triple Crown" @change-mode="changeMode"></tab>
				<tab mode="breeders-cup" text="Breeders' Cup" @change-mode="changeMode"></tab>
				<li class="separator"></li>
				<li class="label">Months</li>
				<li v-for="item in months" class="month" :class="{ 'is-active': month == item.value }">
					<a @click.prevent="monthClick(item)" :data-value="item.value" href="#">{{ item.text }}</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Tab from './Tab.vue'
	import moment from 'moment'
	import Vue from 'vue'
    export default {
	    components: { Tab },
		props: ['mode'],
	    data () {
		    return {
			    month: 'none',
			    mobileFilters: false
		    };
	    },
	    methods: {
		    changeMonth: function () {
			    this.hideMobileFilters();
			    this.$dispatch('change-month', this.month);
		    },
		    monthClick: function(item) {
			    this.month = item.value;
		    },
		    changeMode: function (e, mode) {
			    this.hideMobileFilters();
			    this.$dispatch('change-mode', e, mode);
		    },
		    showMobileFilters: function () {
			    this.mobileFilters = true;
			    Vue.nextTick(function () {
				    window.jQuery(document).trigger('scroll-overlay');
			    });
		    },
		    hideMobileFilters: function () {
			    this.mobileFilters = false;
			    Vue.nextTick(function () {
				    window.jQuery(document).trigger('scroll-overlay');
			    });
		    }
	    },
	    watch: {
		    month: 'changeMonth'
	    },
	    computed: {
		    months: function () {

			    // Store the current year for use later.
			    var year = moment().year();
			    var options = [{ value: 'none', text: 'All Months' }];

			    // Last 5 months and future 5 months.
			    for (var monthNum = -5; monthNum < 5; monthNum++) {
				    var month = moment().add(monthNum, 'months');
				    var option = { value: monthNum, text: month.format('MMMM') };
				    if (month.year() != year) {
					    option.text += ' \'' + month.format('YY');
				    }
				    options.push(option);
			    }

			    return options;

		    }
	    }
    }
</script>



/** WEBPACK FOOTER **
 ** Tabs.vue?4846b675
 **/